import {
	AspectRatioContainer,
	Container,
	CTA,
	Image,
	Richtext,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Agenda } from '@esportal/portal-service';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { PortalContext } from '../../../context/PortalContext';
import { formatOwnership } from '../../../tracking/trackingHelper';
import { actionRedirect } from '../../../helpers/common-helpers';

interface AgendaCardProps {
	agenda: Agenda;
}

const CardContainer = styled.div`
	background: #ffffff;
	border-radius: 16px;
	height: 100%;
	padding: 24px;
	backdrop-filter: blur(10px);

	/* Shadow02 */
	box-shadow:
		0px 2px 4px 0px rgba(0, 14, 38, 0.2),
		0px 3px 15px 0px rgba(0, 14, 38, 0.1);

	/* Mobile & Tablet */
	@media (max-width: 959px) {
		padding-top: var(--size-dynamic0150);
		padding-bottom: var(--size-dynamic0150);
		padding-right: var(--size-dynamic0200);
		padding-left: var(--size-dynamic0200);
	}
`;

const AgendaCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: var(--size-dynamic0050);
`;

// text container ocupa todo el espacio del medio para poder
// alinear el cta en el margen inferior izquierdo
const AgendaTextContainer = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

const AgendaImage = styled(Image)`
	border-radius: 16px;
	backdrop-filter: blur(10px);

	/* Shadow02 */
	box-shadow:
		0px 2px 4px 0px rgba(0, 14, 38, 0.2),
		0px 3px 15px 0px rgba(0, 14, 38, 0.1);
`;

export const AgendaCard = ({ agenda }: AgendaCardProps) => {
	const trackingManager = useTrackingManager();

	const { portalService, userInteractionService } = useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const handleOnClick = (agenda: Agenda) => {
		if (agenda.cta.src) {
			trackingManager.trackClubVWButtonClick(
				'Agenda',
				{ contentId: `${agenda.title}` },
				{ vehicle: formatOwnership(userVehicles?.vehicles) },
			);

			if (agenda.cta.src.includes('action:')) {
				actionRedirect(userInteractionService, agenda.cta.src);
			} else {
				window.open(agenda.cta.src, '_blank');
			}
		}
	};

	return (
		<CardContainer data-testid="agenda-card">
			<AgendaCardContainer>
				<AspectRatioContainer ratio="16:9">
					<AgendaImage src={agenda.imageUrl} alt={agenda.title} />
				</AspectRatioContainer>
				<AgendaTextContainer>
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.left} bold>
						{agenda.title}
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.left}>
						<Richtext markdown={agenda.description} />
					</Text>
				</AgendaTextContainer>
				{agenda.cta.src && (
					<Container horizontalAlign="flex-start">
						<CTA tag="button" emphasis="nbab" onClick={() => handleOnClick(agenda)}>
							Descubre más
						</CTA>
					</Container>
				)}
			</AgendaCardContainer>
		</CardContainer>
	);
};
